import React, { useState, useEffect } from 'react';
import Skeleton from '@mui/material/Skeleton';
import Badge from '@mui/material/Badge';
import Tooltip from '@mui/material/Tooltip';
import TextField from "@mui/material/TextField";
import getCandidateStatusByStatusCode from "../../apis/getCandidateStatusByStatusCode/getCandidateStatusByStatusCode";
import getTrackCandidateInfo from "../../apis/getTrackCandidateInfo/getTrackCandidateInfo";
import { useDebounce } from "../recruitmentLeader/hook.js";
import "./InterviewTable.css";
import DownArrowIcon from '../Icons/downarrowicon';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";



const InterviewTable = (props) => {
    const { idContextTest, userType, userRole, userRecruitmentpartnerId } = props;
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [interviewData, setInterviewData] = useState([]);
    const [totalInterviewDataCount, setTotalInterviewDataCount] = useState(0);
    const [isDataLoading, setIsDataLoading] = useState(true);
    const [currentEventCount, setCurrentEventCount] = useState(0);
    const [page, setPage] = useState(0);
    const rowsPerPage = 5;
    const jsonConfig = require("../../Config.json");
    const debouncedStartDate = useDebounce(startDate, 300);
    const debouncedEndDate = useDebounce(endDate, 300);

    function formatDate(dateString) {
        const date = new Date(dateString);
        const options = { day: "numeric", month: "short", year: "numeric" };
        return date.toLocaleDateString("en-US", options);
    }

    function convertDate(dateString) {
        if (dateString) {
            let date = new Date(dateString),
                month = ("0" + (date.getMonth() + 1)).slice(-2),
                day = ("0" + date.getDate()).slice(-2);
            return [date.getFullYear(), month, day].join("-");
        }
        return '';
    }

    const columns = [
        { id: 'candidateName', label: 'Candidate Name', minWidth: 100 },
        { id: 'referenceId', label: 'Reference ID', minWidth: 100 },
        { id: 'clientName', label: 'Client Name', minWidth: 100 },
        { id: 'interviewDate', label: 'Interview Date', minWidth: 100 },
        { id: 'interviewLevel', label: 'Level', minWidth: 100 }
    ];

    const getInterviewDetails = async (isScroll) => {
        let response;
        try {
            setIsDataLoading(true)

            let payloadData = {
                isCurrentEventCount: true,
                candidateStatusCode: [jsonConfig.candidateRequisitionStatusCode.L1_Interview, jsonConfig.candidateRequisitionStatusCode.L2_Interview, jsonConfig.candidateRequisitionStatusCode.L3_Interview],
                searchData: {},
                role: userType === "Admin" ? userRole : userType,
                recruitmentpartnerId: userRecruitmentpartnerId,
                userRecruitmentpartnerId: userRecruitmentpartnerId,
                userId: idContextTest,
                origin: "interviewTable"
            }

            if (userType === "Organization Admin" || userType === "MIS Operator" || (userType === "Admin" && userRole === "Organization Admin") || (userType === "Admin" && userRole === "MIS Operator")) {
                payloadData.orgId = userRecruitmentpartnerId
            }
            // else if (userType === "MIS Operator" || (userType === "Admin" && userRole === "MIS Operator")) {
            //   payloadData.misOperatorId = id
            // }
            else if (userType === "Recruiter" || (userType === "Admin" && userRole === "Recruiter")) {
                payloadData.recruiterId = idContextTest
            }
            else if (userType === "Recruitment Leader" || (userType === "Admin" && userRole === "Recruitment Leader")) {
                payloadData.recruitmentLeaderId = idContextTest
            } else if (userType === "Team Leader" || (userType === "Admin" && userRole === "Team Leader")) {
                payloadData.teamLeaderId = idContextTest
            }


            let candidateInterviewData = isScroll ? interviewData : []
            let today = new Date();
            let threeDaysLater = new Date();
            let twoDaysLater = new Date();
            let oneDaysLater = new Date();
            threeDaysLater = formatDate(threeDaysLater.setDate(today.getDate() + 3));
            twoDaysLater = formatDate(twoDaysLater.setDate(today.getDate() + 2));
            oneDaysLater = formatDate(oneDaysLater.setDate(today.getDate() + 1));

            let pageCount = isScroll ? page + 1 : 1
            setPage(pageCount)


            payloadData.fromdate = convertDate(startDate)
            payloadData.todate = convertDate(endDate)
            payloadData.page = pageCount
            payloadData.size = rowsPerPage


            response = await getCandidateStatusByStatusCode(payloadData);
            setCurrentEventCount(response.data?.currentEventCount || 0)
            setTotalInterviewDataCount(response.data?.totalCount)
            response = response.data?.data
            response.forEach((details) => {

                let candidateInterviewDate = formatDate(details.eventDate)
                candidateInterviewData.push({
                    candidateName: details.name,
                    interviewLevel: details?.candidateStatus?.name,
                    referenceId: details?.requisitiondetails?.reqreferenceId,
                    clientName: details.clientdata?.clientName,
                    interviewDate: formatDate(details.eventDate),
                    email: details.email,
                    interviewAlert: (candidateInterviewDate === formatDate(today) || candidateInterviewDate === oneDaysLater || candidateInterviewDate === twoDaysLater || candidateInterviewDate === threeDaysLater) ? true : false
                })
            })
            setInterviewData(candidateInterviewData);
            setIsDataLoading(false)
        } catch (error) {
            console.log("Error", error);
        }

    }
    const startDateChangeHandler = (date) => {
        setStartDate(date);
    };
    const endDateChangeHandler = (date) => {
        setEndDate(date);
    };

    useEffect(() => {
        getInterviewDetails(false);
        // eslint-disable-next-line
    }, [debouncedStartDate, debouncedEndDate, userType]);

    const goToCandidateProfile = async (row) => {
        console.log("row", row);

        const response = await getTrackCandidateInfo({
            candidateEmail: row.email,
            recruitmentPartnerId: userRecruitmentpartnerId
        });
        const userData = response?.data?.data?.userDetails;
        console.log("userData", userData);
        let url = '';
        if (userData[0]?.powerResumeId) {
            url = 'candidate/profile/' + userData[0]?.powerResumeId + '/' + userData[0].recruitmentOrgId;
        } else {
            url = 'only-candidate-profile/' + userData[0]?.candidateId;
        }
        window.open(url, "_blank");
    };

    return (
        <div className="bento bento-wide container-interview-table">
            <div className="bento-header">
                <div className="bento-header-content">
                    <div className="bento-header-text interview_table_header">
                        {currentEventCount === 0 ? (
                            <span>Interview</span>
                        ) : (
                            <Tooltip title="Number of Interview scheduled today" placement="top">
                                <Badge badgeContent={currentEventCount} color="secondary">
                                    <span>Interview</span>
                                </Badge>
                            </Tooltip>
                        )}
                    </div>
                    <div className="bento-header-date">
                        <div className="date-filter_interview_table">
                            <div className='date-pill-interview'>
                                <DatePicker
                                    selected={startDate}
                                    className="date-pill-input-interview"
                                    value={startDate || ''}
                                    onChange={startDateChangeHandler}
                                    dateFormat="dd-MM-yyyy"
                                    placeholderText="DD-MM-YYYY"
                                    showIcon
                                />
                            </div>

                            <div className='date-pill-interview'>
                                <DatePicker
                                    selected={endDate}
                                    className="date-pill-input-interview"
                                    value={endDate || ''}
                                    onChange={endDateChangeHandler}
                                    dateFormat="dd-MM-yyyy"
                                    placeholderText="DD-MM-YYYY"
                                    showIcon
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="interview-table-container">
                <table className="interview-table" >
                    <thead >
                        <tr>
                            {columns.map((column) => (
                                <th key={column.id} style={{ minWidth: column.minWidth }}>{column.label}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {isDataLoading
                            ? [0, 1, 2, 3, 4].map((item) => (
                                <tr key={item}>
                                    {columns.map((col) => (
                                        <td key={col.id}><Skeleton /></td>
                                    ))}
                                </tr>
                            ))
                            : (
                                interviewData.length > 0
                                    ? interviewData.map((row, index) => (
                                        <tr
                                            key={row.referenceId || index}
                                            className={row.interviewAlert ? "interviewTable_today" : "interviewTable_today_upcomingDate"}
                                            style={{ cursor: "pointer" }}
                                            onClick={() => goToCandidateProfile(row)}
                                        >
                                            {columns.map((column) => (
                                                <td key={column.id}>
                                                    {row[column.id]}
                                                </td>
                                            ))}
                                        </tr>
                                    ))
                                    : (
                                        <tr>
                                            <td colSpan={columns.length} align="center">
                                                No interviews scheduled
                                            </td>
                                        </tr>
                                    )
                            )}
                    </tbody>
                </table>
            </div>
            {totalInterviewDataCount > interviewData.length && !isDataLoading && (
                <div
                    className="load_more_container_interview_table"
                    onClick={() => getInterviewDetails(true)}
                >
                    <p className="load_more_button_interview_table">
                        Click Here To View More
                    </p>
                    <DownArrowIcon />
                </div>
            )}
        </div>
    );
};

export default InterviewTable;
